// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withIsVisible = require('client-v2/common/components/is-visible')
const AppFooter = require('client-v2/common/containers/app-footer/component-smart')
// Sibling imports
const { defaultFeedSelectors } = require('./selectors')

module.exports = {
  createFeedAwareAppFooter,
  default: createFeedAwareAppFooter(defaultFeedSelectors)
}

function createFeedAwareAppFooter(feedSelectors) {
  function mapStateToProps(state) {
    return {
      isVisible: !feedSelectors.getNextPageUrl(state)
    }
  }

  return (
    connect(
      mapStateToProps
    )(
      withIsVisible(
        AppFooter
      )
    )
  )
}
